import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FacilitiesFormService } from '../../facilities-form.service';
import { EnvironmentService } from '../../../../services/environment.service';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { filter } from 'rxjs/operators';
import { HeatingDeviceObject } from '../../facilities-form.domain';
import { ApplicationSectionKeys } from 'src/app/constants/app.constants';

@Component({
  selector: 'app-district-heat-device',
  templateUrl: './district-heat-device.component.html',
  styleUrls: ['./district-heat-device.component.scss'],
})
export class DistrictHeatDeviceComponent extends DestroyableComponent implements OnInit {
  @Input() isReadOnly: boolean = false;
  @Input() heatingDeviceData: HeatingDeviceObject = null;

  districtHeatDeviceFG: FormGroup;

  applicationSection = ApplicationSectionKeys.technicalData.districtHeatDevice;
  private component = 'districtHeatDevice';

  constructor(public environmentService: EnvironmentService, private facilitiesFormService: FacilitiesFormService) {
    super();
  }

  ngOnInit(): void {
    this.prepareForm();

    this.facilitiesFormService.manageDistrictHeatDeviceFormData({
      component: this.component,
      formData: this.districtHeatDeviceFG,
    });

    this.preventLeak(this.facilitiesFormService.registerForActionOnFormSubmit)
      .pipe(filter(value => value))
      .subscribe(() => this.prepareForm());
  }

  prepareForm(): void {
    this.districtHeatDeviceFG = new FormGroup({
      customFields: new FormControl(this.heatingDeviceData?.customFields || {}),
    });

    this.preventLeak(this.districtHeatDeviceFG.valueChanges).subscribe(() =>
      this.facilitiesFormService.registerForDistrictHeatDeviceUpdate.next({
        component: this.component,
        formData: this.districtHeatDeviceFG,
      })
    );
  }
}
